import { MonumentName, ProjectTotalization } from "interfaces/front/business";
import { BaseClientService, ErrorV2 } from "../BaseClientService";
import { Result } from "../BaseNodeService";

export class FrontProjectPageService extends BaseClientService {
  url: string;

  constructor(slug: string) {
    super();
    this.url = `${this.API_BASE_URL}/api/front/project_page/${slug}`;
  }

  async getData(): Promise<Result<ProjectPageDataOutput, ErrorV2>> {
    return super.doGet<ProjectPageDataOutput, ErrorV2>(this.url, "");
  }
}

export type ProjectPageDataOutput = {
  summary: ProjectTotalization;
  realtime_comment_interval: number;
  monument_names: MonumentName[];
};
